App.controller('RememberCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$stateParams', 'authService', '$mdDialog', 'popUpService', '$rootScope', function ($scope, $sce, $state, $http, Config, $stateParams, authService, $mdDialog, popUpService, $rootScope) {
    $scope.stateParams = $stateParams;

    $scope.token = $scope.stateParams.token;

    authService.loginByChangePasswordToken($scope.token).then(function (data) {
        if (data.status === 200) {
            $scope.login = data.data;
        } else {
            $scope.login = '';
            if (data.data.message === 'TokenExpiredException') {
                popUpService.showPopUpWithError(data.data, {ev: '', head: 'Link jest nieaktywny', content: 'Link autoryzacji do zmiany hasła jest nieaktywny. Skontaktuj się z administratorem lub ponów proces przypominania hasła. ', text: 'Wróć na stronę główną', target: 'root.dashboard'});
                // $scope.showPopUp('', 'Niepoprawny token', 'Token jest niepoprawny lub stracił ważność, skontaktuj się z administratorem lub spróbuj ponownie.', '', '');
            }
        }
    });

    $scope.$watch('password', function () {
        if (!$scope.password) {
            $scope.strongPassword = 0;
            return 0;
        } else {
            $scope.strongPassword = $scope.password.length * 10 / 2;

            if ($scope.strongPassword <= 40) {
                $scope.strongPasswordLabel = 'Słabe';
            } else if ($scope.strongPassword <= 60) {
                $scope.strongPasswordLabel = 'Średnie';
            } else if ($scope.strongPassword <= 80) {
                $scope.strongPasswordLabel = 'Dobre';
            } else {
                $scope.strongPasswordLabel = 'Znakomite';
            }
        }
    });

    $scope.data = {
        hrNumber: '',
        birthplace: ''
    };

    $scope.change = function () {
        var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        var model = {
            newPassword: $scope.password,
            token: $scope.token
        };

        if ($rootScope.CONFIGURATOR.isHrNumberInRememberEnabled) {
            model.hrNumber = $scope.data.hrNumber;
        } else {
            model.birthplace = $scope.data.birthplace;
        }

        authService.changePassword(model).then(function (data) {
            if (data.status === 200) {
                $scope.showPopUp('', 'Hasło zostało zmienione', 'Zmiana hasła powiodła się. Możesz teraz zalogować się do swojego konta.', 'Przejdź do logowania', 'root.login');
            } else {
                if (data.data.message === 'PasswordUsedBeforeException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Niepoprawne hasło', content: 'Hasło musi być różne od 5 ostanio użytych.', text: '', target: ''});
                } else if (data.data.message === 'WrongBirthplaceException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Niepoprawne dane', content: 'Miejsce urodzenia nie jest zgodne z danymi podanymi podczas rejestracji. Skontaktuj się z administratorem lub spróbuj ponownie.', text: '', target: ''});
                } else if (data.data.message === 'WrongHrNumberException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Niepoprawne dane', content: 'Numer kadrowy nie jest zgodny z danymi podanymi podczas rejestracji. Skontaktuj się z administratorem lub spróbuj ponownie.', text: '', target: ''});
                } else if (data.data.message === 'TokenExpiredException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Link jest nieaktywny', content: 'Link autoryzacji do zmiany hasła jest nieaktywny. Skontaktuj się z administratorem lub ponów proces przypomnienia hasła.', text: '', target: ''});
                } else {
                    popUpService.showPopUpWithError(data.data, {head:'Wystąpił błąd', content:'Skontaktuj się z administratorem lub spróbuj ponownie.'});
                }
            }
        });
    }

    $scope.showPopUp = function (ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {

        }, function () {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }
}]);
